// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/sections/Portfolio.css */
.portfolio {
  padding: 100px 0;
  background: linear-gradient(180deg, var(--dark-bg) 0%, var(--dark-secondary) 100%);
  position: relative;
  overflow: hidden;
}

.portfolio::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 800px;
  height: 800px;
  background: radial-gradient(circle, rgba(79, 172, 254, 0.1) 0%, transparent 70%);
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.portfolio-showcase {
  position: relative;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 40px;
}

.carousel-button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--text-primary);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.carousel-button:hover {
  background: var(--primary-color);
  color: var(--dark-bg);
  transform: scale(1.1);
}

.portfolio-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  flex: 1 1;
}

.portfolio-preview {
  perspective: 1000px;
}

.preview-screen {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  transform: rotateY(-10deg);
  transition: transform 0.3s ease;
}

.preview-screen:hover {
  transform: rotateY(0deg);
}

.preview-header {
  background: rgba(40, 40, 40, 0.95);
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.preview-controls {
  display: flex;
  gap: 8px;
}

.preview-controls .control {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
}

.preview-url {
  background: rgba(255, 255, 255, 0.1);
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.preview-content {
  padding: 20px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.project-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.project-image:hover {
  transform: scale(1.02);
}

.project-emoji {
  font-size: 100px;
  filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.3));
  animation: float 3s ease-in-out infinite;
}

.portfolio-details {
  text-align: left;
}

.project-title {
  font-size: 2.5rem;
  margin-bottom: 20px;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.project-description {
  font-size: 1.1rem;
  color: var(--text-secondary);
  margin-bottom: 30px;
  line-height: 1.8;
}

.project-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 30px;
}

.tag {
  padding: 6px 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  font-size: 0.9rem;
  color: var(--text-primary);
}

.project-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.project-link svg {
  transition: transform 0.3s ease;
}

.project-link:hover svg {
  transform: translateX(5px);
}

.portfolio-indicators {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 40px;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  width: 30px;
  border-radius: 5px;
  background: var(--primary-color);
}

/* Responsive */
@media (max-width: 968px) {
  .portfolio-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .preview-screen {
    transform: none;
    max-width: 400px;
    margin: 0 auto;
  }
  
  .portfolio-details {
    text-align: center;
  }
  
  .project-tags {
    justify-content: center;
  }
  
  .carousel-button {
    display: none;
  }
}

@media (max-width: 480px) {
  .project-title {
    font-size: 2rem;
  }
  
  .project-description {
    font-size: 1rem;
  }
  
  .preview-content {
    height: 200px;
  }
  
  .project-emoji {
    font-size: 60px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/sections/Portfolio.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,kFAAkF;EAClF,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* src/components/sections/Portfolio.css */\n.portfolio {\n  padding: 100px 0;\n  background: linear-gradient(180deg, var(--dark-bg) 0%, var(--dark-secondary) 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.portfolio::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 800px;\n  height: 800px;\n  background: radial-gradient(circle, rgba(79, 172, 254, 0.1) 0%, transparent 70%);\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n\n.portfolio-showcase {\n  position: relative;\n  max-width: 1000px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 40px;\n}\n\n.carousel-button {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: var(--text-primary);\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.carousel-button:hover {\n  background: var(--primary-color);\n  color: var(--dark-bg);\n  transform: scale(1.1);\n}\n\n.portfolio-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 60px;\n  align-items: center;\n  flex: 1;\n}\n\n.portfolio-preview {\n  perspective: 1000px;\n}\n\n.preview-screen {\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  transform: rotateY(-10deg);\n  transition: transform 0.3s ease;\n}\n\n.preview-screen:hover {\n  transform: rotateY(0deg);\n}\n\n.preview-header {\n  background: rgba(40, 40, 40, 0.95);\n  padding: 15px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.preview-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.preview-controls .control {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.preview-url {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 5px 15px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.preview-content {\n  padding: 20px;\n  height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.project-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease;\n}\n\n.project-image:hover {\n  transform: scale(1.02);\n}\n\n.project-emoji {\n  font-size: 100px;\n  filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.3));\n  animation: float 3s ease-in-out infinite;\n}\n\n.portfolio-details {\n  text-align: left;\n}\n\n.project-title {\n  font-size: 2.5rem;\n  margin-bottom: 20px;\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.project-description {\n  font-size: 1.1rem;\n  color: var(--text-secondary);\n  margin-bottom: 30px;\n  line-height: 1.8;\n}\n\n.project-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 30px;\n}\n\n.tag {\n  padding: 6px 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 20px;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n}\n\n.project-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.project-link svg {\n  transition: transform 0.3s ease;\n}\n\n.project-link:hover svg {\n  transform: translateX(5px);\n}\n\n.portfolio-indicators {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 40px;\n}\n\n.indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.indicator.active {\n  width: 30px;\n  border-radius: 5px;\n  background: var(--primary-color);\n}\n\n/* Responsive */\n@media (max-width: 968px) {\n  .portfolio-content {\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n  \n  .preview-screen {\n    transform: none;\n    max-width: 400px;\n    margin: 0 auto;\n  }\n  \n  .portfolio-details {\n    text-align: center;\n  }\n  \n  .project-tags {\n    justify-content: center;\n  }\n  \n  .carousel-button {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .project-title {\n    font-size: 2rem;\n  }\n  \n  .project-description {\n    font-size: 1rem;\n  }\n  \n  .preview-content {\n    height: 200px;\n  }\n  \n  .project-emoji {\n    font-size: 60px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
